import React from "react";
import { ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { Icon } from "../Icon";
import styles from "./styles.module.css";

// TODO move to core

type BaseVideoProps = {
	src?: string;
	width?: number;
	height?: number;
	size?: string;
	sizing?: "auto" | "width-scaled" | "height-scaled" | "cover" | "contain";
	title?: string;
} & Partial<ClassNameProps & StyleProps>;

export type VideoPreviewProps = BaseVideoProps;

export function VideoPreview({
	src = "",
	width,
	height,
	size,
	sizing = "auto",
	title,
	className,
	style,
}: VideoPreviewProps) {
	return (
		<div
			title={title}
			className={makeClassName(styles["video"], styles[`video--${sizing}`], className)}
			style={
				{
					width: width !== undefined ? `${width}px` : size,
					height: height !== undefined ? `${height}px` : size,
					...style,
				} as React.CSSProperties
			}
		>
			<div className={styles["video--preview__play-overlay"]}>
				<Icon.PlayCircle className={styles["video--preview__play-overlay__icon"]} />
			</div>
			<video width={width} height={height}>
				<source src={src} type="video/mp4" />
			</video>
		</div>
	);
}

type VideoProps = BaseVideoProps & {
	controls?: boolean;
	autoPlay?: boolean;
	loop?: boolean;
};

export function Video({
	src = "",
	width,
	height,
	controls,
	autoPlay,
	loop,
	size,
	sizing = "auto",
	title,
	className,
	style,
}: VideoProps) {
	return (
		<div
			title={title}
			className={makeClassName(styles["video"], styles[`video--${sizing}`], className)}
			style={
				{
					width: width !== undefined ? `${width}px` : size,
					height: height !== undefined ? `${height}px` : size,
					...style,
				} as React.CSSProperties
			}
		>
			<video width={width} height={height} autoPlay={autoPlay} loop={loop} controls={controls}>
				<source src={src} type="video/mp4" />
			</video>
		</div>
	);
}
